import React from 'react';

import ConfigurationButton from 'components/Buttons/ConfigurationButton';
import EditButton from 'components/Buttons/EditCircleButton';
/* import AddCircleButton from 'components/Buttons/AddCircleButton'; */
import ImpersonateCircleButton from 'components/Buttons/ImpersonateCircleButton';
import useIsUserType from 'hooks/useIsAdmin';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import history from 'utils/history';

import { Actions, Container, Content, Header, Icon, IconChar, InactiveIcon, StatusButton } from './styles';

interface Props {
  billingCompany: GetAllBillingCompanyResponse;
  onEdit: () => void;
  onSelectToImpersonate?: () => void;
  onToggleStatus?: () => void;
  loading?: boolean;
  currentCompanyId: string;
}

const BillingCompanyItem = ({
  billingCompany,
  onSelectToImpersonate,
  onEdit,
  onToggleStatus,
  loading,
  currentCompanyId,
}: Props) => {
  const { t } = useStoreTranslation();
  const isSupportImplementation = useIsUserType('supportImplementation');
  const isActive = billingCompany.isActive !== false;

  return (
    <Container inactive={!isActive}>
      <Content>
        {billingCompany.selected && <Icon src="/corporate/images/company-selected-icon.svg" alt="" />}
        {billingCompany.isHolding && <IconChar>👑</IconChar>}
        {!isActive && <InactiveIcon />}
        <Header>
          <Header.Title>{billingCompany.companyName}</Header.Title>
          <Header.Text>
            {t('branchCompany.list.document')}: {billingCompany.document}
          </Header.Text>
          {billingCompany.isHolding && (
            <Header.Type selected={billingCompany.selected}>{t('branchCompany.list.reseller')}</Header.Type>
          )}
          {!billingCompany.isHolding && (
            <Header.Type selected={billingCompany.selected}>{t('branchCompany.list.customer')}</Header.Type>
          )}
        </Header>
        <Actions>
          {isSupportImplementation && (
            <StatusButton
              type="button"
              active={isActive}
              disabled={loading}
              onClick={(event) => {
                event.stopPropagation();
                if (onToggleStatus) onToggleStatus();
              }}
            >
              {isActive ? t('branchCompany.list.deactivate') : t('branchCompany.list.activate')}
            </StatusButton>
          )}
          <EditButton onClick={onEdit ? onEdit : () => {}} />
          {billingCompany.id !== currentCompanyId && (
            <ImpersonateCircleButton onClick={onSelectToImpersonate ? onSelectToImpersonate : () => {}} />
          )}
          <ConfigurationButton
            style={{ display: 'none' }}
            onClick={() => history.push(`/corporate/companyConfigurationUpdate/${billingCompany.id}`)}
          />
        </Actions>
      </Content>
    </Container>
  );
};

export default BillingCompanyItem;
